// extracted by mini-css-extract-plugin
export var chip = "_cd-0";
export var filterDropdown = "_cd-5";
export var filterItem = "_cd-6";
export var icon = "_cd-1";
export var removeButton = "_cd-3";
export var removeIcon = "_cd-4";
export var separator = "_cd-2";